import React, { useEffect, useState } from "react";
import bannerImg from "../../assets/images/lead-gen-form.jpg";
import Svg from "../../common/Svg";
import { useDispatch, useSelector } from "react-redux";
import { GetToken } from "../../store/actions/tokenAction";
import {
  checkPublish,
  getLeadFormData,
  submitLeadFormData,
  updateSubmitedSurveyByEloqua,
  getGroupLanguages,
  getCookiePolicy,
} from "../../store/actions/leadFormAction";
import { getCountryCodes, getActiveWebhooks, getSurveyDetail } from "../../store/actions/surveyFormAction";
import CustomInput from "./components/CustomInput";
import LanguageSwitcher from "./components/LanguageSwitcher";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Axios from "axios";
import { triggerWebhookBackend } from "../../store/actions/surveyFormAction";
import SurveyCookieBanner from "../../component/SurveyCookieBanner";
import { getRequiredText, getOnlyNumbersText, getMaxLengthText } from "../../utils/validationTranslations";

export default function LandingPage() {
  //Store config
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { leadFormData, groupLanguages, groupLanguagesLoading, cookiePolicy } = useSelector((state) => state.leadFormData);
  const { publishData, publishLoading } = useSelector((state) => state.publishData);
  
  const { countryCodes } = useSelector((state) => state.surveyData);
  const surveyDetail = useSelector((state) => state.surveyData?.surveyDetail);

  // Map survey language name → default phone country code (fallback)
  const LANGUAGE_PHONE_DEFAULTS = {
    'english':    '+44',  // UK
    'portuguese': '+351', // Portugal
    'albanian':   '+355', // Albania
    'irish':      '+353', // Ireland
  };
  const getDefaultPhoneCode = (surveyDetailRow) => {
    // Prefer team country code if available
    if (surveyDetailRow?.team_country_code) {
      const code = surveyDetailRow.team_country_code.trim();
      return code.startsWith('+') ? code : `+${code}`;
    }
    // Fall back to language-based mapping
    const languageName = surveyDetailRow?.language_name;
    if (!languageName) return '+44';
    return LANGUAGE_PHONE_DEFAULTS[languageName.toLowerCase()] || '+44';
  };
const webhookActiveList = useSelector((state) => state?.surveyData?.webhookActiveList || []);
    console.log(webhookActiveList, "webhookActiveList")





  console.log("publishData-1", publishData);

  //Params data
  const { survey_id, group_id } = useParams();
  const [searchparams, setSearchparams] = useSearchParams();
  const [heading, setHeading] = useState("");
  const [description, setDescription] = useState("");
  const [privacy, setPrivacy] = useState("");
  const [submitTitle, setSubmitTitle] = useState("");
  const [submitPosition, setSubmitPosition] = useState("Left");
  const [TandC, setTandC] = useState("");
  const [bannerUploadedUrl, setBannerUploadedUrl] = useState("");
  const [bannerSrc, setBannerSrc] = useState(bannerImg);
  const [cookieDecision, setCookieDecision] = useState(null);
  const apiBaseUrl = (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.replace(/\/$/, "")) || window.location.origin;

  const resolveBannerSrc = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    const cleaned = path.replace(/^\/+/, "");
    return `${apiBaseUrl}/frnt/file/${cleaned}`;
  };

  const params = {};
  const [surveyLinkUrl, setSurveyLinkUrl] = useState(1);
  searchparams.forEach((value, key) => {
    params[key] = value;
  });

  //Language
  const language = localStorage.getItem("customer_language") ?? "22";


  const replaceVariables = (url, formData) => {
  try {
    const [baseUrl, queryString] = url.split("?");
    const params = new URLSearchParams(queryString);

    for (let [key, value] of params.entries()) {
      const actualValue = formData[value] || value;
      params.set(key, actualValue); // Don't double encode here
    }

    return `${baseUrl}?${params.toString()}`; // Let browser encode as needed
  } catch (error) {
    console.error("Error in replaceVariables:", error);
    return url;
  }
};



  const triggerWebhooks = (eventName, formData) => {
  const filteredWebhooks = webhookActiveList.filter(w => w.event === eventName);
   console.log("filtered webhok",filteredWebhooks)
      console.log("formData",formData)

  filteredWebhooks.forEach((webhook) => {
   // const populatedUrl = replaceVariables(webhook.webhook_url, formData);
      const vars = JSON.parse(webhook.variables || "[]");

   // Build payload with ONLY selected fields
   const payloadData = {};
   vars.forEach(v => {
     if (v.type === "STATIC_FIELD") {
       payloadData[v.name] = v.value ?? "";
     } else {
       payloadData[v.name] = formData[v.value] ?? "";
     }
  });

   const populatedUrl = replaceVariables(webhook.webhook_url, payloadData);
    
    // Prepare request options based on webhook configuration
    const requestOptions = {
      method: webhook.http_method || 'POST',
      mode: 'no-cors',   
      headers: {
        'Content-Type': webhook.content_type || 'application/x-www-form-urlencoded'
      }
    };

    // Handle different data formats and HTTP methods
    if (webhook.http_method === 'GET') {
      delete requestOptions.headers['Content-Type'];
    } else if (webhook.data_format === 'request_body') {
      // Send data in request body for POST requests
      if (webhook.content_type === 'application/json') {
        requestOptions.body = JSON.stringify(formData);
      } else if (webhook.content_type === 'application/x-www-form-urlencoded') {
        const formDataBody = new URLSearchParams();
        Object.keys(formData).forEach(key => {
          if (formData[key] !== undefined && formData[key] !== null) {
            formDataBody.append(key, formData[key]);
          }
        });
        requestOptions.body = formDataBody.toString();
      } else if (webhook.content_type === 'multipart/form-data') {
        const formDataBody = new FormData();
        Object.keys(payloadData).forEach(key => {
          if (payloadData[key] !== undefined && payloadData[key] !== null) {
            formDataBody.append(key, payloadData[key]);
          }
        });
      
        delete requestOptions.headers['Content-Type'];
        requestOptions.body = formDataBody;
      }
    } else {
     
    }

    console.log(`[Frontend Webhook Config] ${webhook.name}:`, {
      method: webhook.http_method,
      contentType: webhook.content_type,
      dataFormat: webhook.data_format,
      url: populatedUrl
    });

    fetch(populatedUrl, requestOptions)
    .then((res) => {
      console.log(`[Webhook Triggered] ${webhook.name} → ${res.status}`);
    })
    .catch((err) => {
      console.error("Webhook Trigger Error:", err);
    });
  });
};


  // Static UI message translations keyed by survey language name
  const STATIC_TRANSLATIONS = {
    albanian: {
      acceptConditions: "Ju lutemi pranoni kushtet për të vazhduar",
    },
    portuguese: {
      acceptConditions: "Por favor, aceite as condições para prosseguir",
    },
    irish: {
      acceptConditions: "Please accept conditions to go ahead",
    },
    english: {
      acceptConditions: "Please accept conditions to go ahead",
    },
  };
  const surveyLangName = surveyDetail?.length > 0 ? surveyDetail[0]?.language_name?.toLowerCase() : "english";
  const staticMessages = STATIC_TRANSLATIONS[surveyLangName] || STATIC_TRANSLATIONS.english;
  const requiredText = getRequiredText(surveyLangName);
  const onlyNumbersText = getOnlyNumbersText(surveyLangName);

  const applyMaxLength = (schema, maxLen, title) => {
    if (maxLen && Number(maxLen) > 0) {
      return schema.max(Number(maxLen), getMaxLengthText(surveyLangName, maxLen));
    }
    return schema;
  };

  const applyOnlyNumber = (schema, isOnlyNumber) => {
    if (isOnlyNumber) {
      return schema.matches(/^\d*\.?\d*$/, onlyNumbersText);
    }
    return schema;
  };

  //Yup - Schema
  let schemaShape = {};
console.log("leadFormData--",leadFormData)
  leadFormData?.forEach((item) => {
    if (item.su_form_variable_type === 6) return;

    const title = item.su_label_and_options
      ? JSON.parse(item.su_label_and_options)[language]
      : "";
    const key = item.su_name;

    if (item.su_form_variable_type === 1) {
      const attributes = item.su_options && JSON.parse(item.su_options)["0"];

      if (attributes?.required && attributes?.type === "text") {
        let field = Yup.string()
          .test(
            "Whitespace check",
            `${title} can not start with white space`,
            async (value) => {
              if (!value) return true;
              return value.toString()[0] !== " ";
            }
          )
          .required(`${title} ${requiredText}`);
        field = applyMaxLength(field, attributes?.maxLength, title);
        field = applyOnlyNumber(field, attributes?.onlyNumber);
        schemaShape[key] = field;
      } else if (attributes?.type === "email" && !attributes?.required) {
        schemaShape[key] = Yup.string()
          .email("Invalid email")
          .test(
            "Email check",
            `Please enter an email with valid top-level domains`,
            async (value) => {
              if (!value) return true;
              const domain = value.split("@")[1];
              const allowedDomainList = [
                "gmail.com",
                "outlook.com",
                "hotmail.com",
                "yahoo.com",
              ];
              return !allowedDomainList.includes(domain);
            }
          );
      }
      else if (attributes?.required && attributes?.type === "email") {
        schemaShape[key] = Yup.string()
          .email("Invalid email")
          .test(
            "Business email check",
            attributes?.businessEmailVerification === false
              ? "Please enter a valid email address"
              : "Please enter a valid business email address",
            (value) => {
              if (!value) return true;

              const parts = value.split("@");
              if (parts.length !== 2) {
                return false;
              }

              const domain = parts[1];

              const domainSegments = domain.split(".");
              if (
                domainSegments.length < 2 ||
                domainSegments[1].length < 2
              ) {
                return false;
              }

              if (attributes?.businessEmailVerification === false) {
                return true;
              }

              const allowedDomainList = [
                "gmail.com",
                "outlook.com",
                "hotmail.com",
                "yahoo.com",
              ];
              return !allowedDomainList.includes(domain);
            }
          )
          .required(`${title} ${requiredText}`);
      }

      else if (attributes?.required && attributes?.type === "checkbox") {
        schemaShape[key] = Yup.array()
          .of(Yup.string())
          .min(1, `${title} ${requiredText}`);
      } else if (attributes?.type === "checkbox") {
        schemaShape[key] = Yup.array().of(Yup.string());
      } else if (attributes?.required) {
        let field = Yup.string()
          .required(`${title} ${requiredText}`);
        field = applyMaxLength(field, attributes?.maxLength, title);
        field = applyOnlyNumber(field, attributes?.onlyNumber);
        schemaShape[key] = field;
      } else {
        let field = Yup.string();
        field = applyMaxLength(field, attributes?.maxLength, title);
        field = applyOnlyNumber(field, attributes?.onlyNumber);
        schemaShape[key] = field;
      }
    } else if (item.su_form_variable_type === 3) {
      const attributes = item?.su_options && JSON.parse(item.su_options);
      if (attributes?.required) {
        schemaShape[key] = Yup.string().required(`${title} ${requiredText}`);
      } else {
        schemaShape[key] = Yup.string();
      }
    } else if (item.su_form_variable_type === 4) {
      const attributes = item?.su_options && JSON.parse(item.su_options);
      let field = attributes?.required
        ? Yup.string().required(`${title} ${requiredText}`)
        : Yup.string();
      field = applyMaxLength(field, attributes?.maxLength, title);
      schemaShape[key] = field;
    } else if (item.su_form_variable_type === 99 && item.su_name === "TANDC") {
      let tancRequired = item?.su_options && JSON.parse(item?.su_options);
      tancRequired = tancRequired ? tancRequired.required : false;
      tancRequired = tancRequired ? true : false;
      if (tancRequired)
        schemaShape[key] = Yup.array()
          .of(Yup.string())
          .min(1, staticMessages.acceptConditions);
      else schemaShape[key] = Yup.array().of(Yup.string());
    }
  });


  // If we know the contact number field name (e.g., "busPhone") and we want the country code required:
  // Add country code validation if necessary
  // We'll store country code separately in formik under 'busPhoneCountryCode'
  // schemaShape["busPhoneCountryCode"] = Yup.string().required("Country Code Required");

  //Formik
  const Schema = Yup.object().shape(schemaShape);

  const formik = useFormik({
    validationSchema: Schema,

    onSubmit: (values) => {
      console.log("values--", values)
      // Merge country code + local number for all phone fields (busPhone or type 'number')
      leadFormData?.forEach(item => {
        if (Number(item.su_form_variable_type) !== 1) return;
        const opts = item.su_options && JSON.parse(item.su_options);
        const isPhone = item.su_name === "busPhone" || opts?.["0"]?.type === "number";
        if (isPhone) {
          const ccKey = item.su_name + "CountryCode";
          if (values[ccKey] && values[item.su_name]) {
            values[item.su_name] = values[ccKey] + values[item.su_name];
            delete values[ccKey];
          }
        }
      });
      const payload = {
        lead_data: {
          ...values,
          natureOfEnquiry: "More info on Cloud and Hosting",
        },
        survey_id: survey_id,
        su_lead_info: JSON.stringify(params),
        lid: params.lid,
      };
     dispatch(submitLeadFormData(payload, navigate)).then((res) => {
      console.log("res-",res)
        const ss_id = res?.ss_id;
        console.log("ssId-",ss_id)
        dispatch(triggerWebhookBackend(survey_id, "LEAD_FORM_SUBMIT", ss_id));
      });

    },
    validateOnMount: true,
    initialValues: {} // Will set dynamically below
  });

  //Effects
  useEffect(() => {
    localStorage.setItem("customer_language", "22");
    dispatch(GetToken()).then(() => {
      dispatch(checkPublish({ survey_id }));
      if (survey_id) {
        dispatch(getCookiePolicy(survey_id));
        dispatch(getActiveWebhooks(survey_id));
        dispatch(getSurveyDetail({ survey_id }));
      }
      if (group_id) {
        dispatch(getGroupLanguages(group_id));
      }
    });
  }, []);

  useEffect(() => {
    if (publishData == 1) {
      dispatch(getLeadFormData({ survey_id }, navigate));
    }
    //dispatch(getCountryCodes());
  }, [publishData]);

  useEffect(() => {
    dispatch(getCountryCodes());
  }, []);

  // Update country code defaults when survey detail (team country code / language) becomes available
  useEffect(() => {
    if (surveyDetail?.length > 0) {
      const defaultCode = getDefaultPhoneCode(surveyDetail[0]);
      const phoneFields = leadFormData?.filter(item => {
        if (Number(item.su_form_variable_type) !== 1) return false;
        const opts = item.su_options && JSON.parse(item.su_options);
        return item.su_name === "busPhone" || opts?.["0"]?.type === "number";
      }) || [];
      phoneFields.forEach(item => {
        if (defaultCode) {
          formik.setFieldValue(item.su_name + "CountryCode", defaultCode);
        }
      });
    }
  }, [surveyDetail]);

  // Keep a stable banner src; if the backend file is missing (404), fall back to a static image.
  useEffect(() => {
    if (bannerUploadedUrl) {
      setBannerSrc(resolveBannerSrc(bannerUploadedUrl));
    } else {
      setBannerSrc(bannerImg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerUploadedUrl, apiBaseUrl]);

  useEffect(() => {
    if (leadFormData?.length > 0) {
      let tmpinitialValues = {};
      let tmpinitialTouched = {};

      leadFormData?.forEach((item) => {
        const key = item.su_name;

        if (Number(item.su_form_variable_type) === 6) return;

        tmpinitialValues[key] = "";
        tmpinitialTouched[key] = false;

        if (Number(item.su_form_variable_type) === 1) {
          let options = item?.su_options && JSON.parse(item?.su_options);
          if (options["0"].type === "checkbox") {
            tmpinitialValues[key] = [];
          }
        }
        if (Number(item.su_form_variable_type) === 5) {
          let options = item?.su_options && JSON.parse(item?.su_options);
          if (options["0"].type === "hidden") {
            tmpinitialValues[key] = options["0"].defaultValue;
          }
        }

        if (item.su_name === "HEADING") {
          const tmpHeading =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          setHeading(tmpHeading);
        }

        if (item.su_name === "DESC") {
          const tmpDesc =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          setDescription(tmpDesc);
        }

        if (item.su_name === "PRIVACY") {
          const tmpPrivacy =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          setPrivacy(tmpPrivacy);
        }

        if (item.su_name === "BANNER") {
          const tmpBanner =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          setBannerUploadedUrl(tmpBanner || "");
        }

        if (item.su_name === "SUBMIT") {
          const tmpHeading =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          let position = item.su_options && JSON.parse(item.su_options);
          position = position ? position.alignment : "Left";
          position =
            position === "Left"
              ? "start"
              : position === "Right"
                ? "end"
                : "center";
          setSubmitPosition(position);
          setSubmitTitle(tmpHeading);
        }

        if (item.su_name === "TANDC") {
          tmpinitialValues["TANDC"] = [];
          const tmpHeading =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          setTandC(tmpHeading);
        }

        // For phone fields (busPhone or type 'number'), add a companion country code field
        if (Number(item.su_form_variable_type) === 1) {
          let phoneOptions = item?.su_options && JSON.parse(item?.su_options);
          if (item.su_name === "busPhone" || phoneOptions?.["0"]?.type === "number") {
            const detailRow = surveyDetail?.length > 0 ? surveyDetail[0] : null;
            tmpinitialValues[item.su_name + "CountryCode"] = getDefaultPhoneCode(detailRow);
          }
        }

      });

      formik.setTouched(tmpinitialTouched);
      formik.setValues(tmpinitialValues);
    }
  }, [language, leadFormData]);

  // Function to handle manual submission validation
  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Mark all fields as touched
    const allTouched = {};
    Object.keys(formik.values).forEach((key) => {
      allTouched[key] = true;
    });

    if (!formik.touched.TANDC) {
      allTouched.TANDC = true;
    }

    formik.setTouched(allTouched, true);

    if (Object.keys(formik.errors).length === 0) {
      formik.handleSubmit();
    }
  };


  const checkSurveyLinkUrl = (surveyLinkId) => {
    Axios.post(process.env.REACT_APP_API_URL + "/frnt/getSurveyLinkById", {
      survey_link_id: surveyLinkId
    })
      .then((response) => {
        console.log("response", response);
        if (response.data.data[0].is_active === 1) {
      
          setSurveyLinkUrl(1)
        } else {
          setSurveyLinkUrl(0)
        }
      })
      .catch((error) => {
        console.error("Error survey link:", error);
      });
  }

  useEffect(() => {
    if (params.lid) {
      checkSurveyLinkUrl(params.lid);
      
    }
    
  }, [])
  console.log("setSurveyLinkUrl--", surveyLinkUrl);
  return (
    <>
      {publishData === 1 && surveyLinkUrl === 1 && (
        <>
          {cookiePolicy && cookiePolicy.is_enabled === 1 && (
            <SurveyCookieBanner
              surveyId={survey_id}
              content={cookiePolicy.cookie_content}
              language={surveyLangName}
              cookiePolicyData={cookiePolicy}
              onCookieDecision={(decision) => setCookieDecision(decision)}
            />
          )}
          <div className="lead-gen-wrapper">
            {group_id && (
              <LanguageSwitcher 
                languages={groupLanguages} 
                currentSurveyId={survey_id}
                groupId={group_id}
              />
            )}
            <div className="row gx-0">
              <div className="col-lg-6 d-none d-lg-flex">
                <div className="img-wrapper">
                  <img
                    src={bannerSrc}
                    alt="bannerImg"
                    onError={(e) => {
                      // If synced DB record points to a missing file on disk, show static placeholder.
                      if (bannerSrc !== bannerImg) {
                        if (e?.currentTarget) e.currentTarget.onerror = null; // prevent loops
                        setBannerSrc(bannerImg);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="text-wrapper">
                  <div className="text-inner">
                    <div className="heading-wrapper">
                      <h1>{heading ?? ""}</h1>
                      {description && <p className="form-description">{description}</p>}
                    </div>
                    <div className="form-wrapper">
                      <form onSubmit={handleFormSubmit}>
                        <div className="row">
                          {leadFormData?.map((item) => (
                            <CustomInput
                              fieldData={item}
                              className={"mb-4"}
                              key={item.su_name}
                              formikData={formik}
                              countryCodes={countryCodes}
                              onlyNumbersText={onlyNumbersText}
                            />
                          ))}
                        </div>

                        {TandC && (
                          <div className="tandc-checkbox-wrapper">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="TANDC"
                                name="TANDC"
                                value="accepted"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    formik.setFieldValue("TANDC", ["accepted"]);
                                  } else {
                                    formik.setFieldValue("TANDC", []);
                                  }
                                }}
                                onBlur={() => formik.setFieldTouched("TANDC", true)}
                              />
                              <label
                                className={"form-check-label"}
                                htmlFor={`TANDC`}
                                dangerouslySetInnerHTML={{
                                  __html: (TandC || '')
                                    .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ')
                                }}
                              />
                            </div>
                            {formik.touched.TANDC && formik.errors.TANDC && (
                              <div className="error" style={{ marginTop: '4px' }}>{formik.errors.TANDC}</div>
                            )}
                          </div>
                        )}
                        <br />
                        <div
                          className="btn-wrapper"
                          style={{
                            display: "flex",
                            justifyContent: submitPosition,
                          }}
                        >
                          <button
                            className="btn btn-primary btn-icon"
                            type="submit"
                            disabled={cookiePolicy?.is_enabled === 1 && cookieDecision !== 'accepted'}
                            style={cookiePolicy?.is_enabled === 1 && cookieDecision !== 'accepted' ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                          >
                            {submitTitle ?? "Submit"} <Svg name="button-icon" />
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="desclaimer-text">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: (privacy || '')
                          .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ')
                          .replace(/https?:\/\/www\.w3schools\.com/g, `/${survey_id}/privacy-policy`)
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
     {!publishLoading && (publishData !== 1 || surveyLinkUrl !== 1) && (
  <h1>Survey yet not published.</h1>
)}

    </>
  );
}